import { Buffer } from 'buffer'

import axios, { InternalAxiosRequestConfig, RawAxiosRequestHeaders } from 'axios'
import { isBefore, parse } from 'date-fns'
import { JwtPayload } from 'jsonwebtoken'

import { toast } from '@shared/components/Toast/utils/toast'
import { UrlConfig } from '@shared/configs/URL'
import { Storage } from '@shared/constants/Storage'

import { Tokens } from '@modules/auth/types/Auth/auth'
import { SignInByRefreshResponse } from '@modules/auth/types/Auth/requests'

export class HandleRequestsFunctions {
  private static convertExpirationStringToDate = (exp: string): Date => {
    return parse(exp, 't', new Date())
  }

  private static getPayloadToken(token: string): JwtPayload {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(Buffer.from(base64, 'base64').toString())

    return JSON.parse(jsonPayload)
  }

  private static expirationIsInvalidFromToken(): boolean {
    const tokens = localStorage.getItem(Storage.TOKENS)

    if (tokens) {
      const { accessToken }: Tokens = JSON.parse(tokens)
      const payload = this.getPayloadToken(accessToken)

      if (payload.exp) {
        return isBefore(this.convertExpirationStringToDate(payload.exp.toString()), new Date())
      }

      return true
    }

    return true
  }

  private static async validateAccessToken(): Promise<void> {
    const expirationTokenIsInvalid = this.expirationIsInvalidFromToken()

    const tokens = localStorage.getItem(Storage.TOKENS)

    if (tokens && expirationTokenIsInvalid) {
      try {
        const { accessToken, refreshToken }: Tokens = JSON.parse(tokens)

        const url = `${UrlConfig.companiesApiUrl}/sessions/refresh-token`

        const { data } = await axios.post<SignInByRefreshResponse>(
          url,
          { profile: 'CUSTOMER', refreshToken },
          { headers: { Authorization: `Bearer ${accessToken}` } },
        )

        localStorage.setItem(
          Storage.TOKENS,
          JSON.stringify({ accessToken: data.accessToken, customToken: data.customToken, refreshToken }),
        )
      } catch {
        toast('Sua sessão expirou, acesse novamente!', { type: 'error' })
      }
    }
  }

  static async handleRequest(request: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
    const headers = { ...request.headers } as RawAxiosRequestHeaders

    await this.validateAccessToken()

    if (!headers?.Authorization) {
      const tokens = localStorage.getItem(Storage.TOKENS)

      if (tokens && JSON.parse(tokens)) {
        const { accessToken, customToken }: Tokens = JSON.parse(tokens)

        Object.assign(request, {
          headers: {
            ...request.headers,
            Authorization: `Bearer ${accessToken}`,
            'x-custom-authorization': `Bearer ${customToken}`,
          },
        })
      }
    }

    return request
  }
}
